"use strict";

var impersonationService = angular.module('service.impersonation', []);

impersonationService.factory('impersonationService', ['$http', 'halClient', 'appSettings', 'localStorageService', 'storageKeys','$log','$window','$location','authenticationService','configuration',
    function($http, halClient, appSettings, localStorageService, storageKeys, $log, $window, $location, authenticationService, configuration){

        var loggedInStoreUsersKey="storeUsersForLoggedInStore";

        function isImpersonationMode(){
            return localStorageService.get(storageKeys.loginTypeKey) === appSettings.impersonationLoginType;
        }

        function isUserImpersonated(){
            return localStorageService.get(storageKeys.impersonatedKey)
        }

        return {
            redirectToImpersonationIfApplicable: function() {
                var impersonatedMode = isImpersonationMode();
                if (impersonatedMode) {
                    $location.path('/impersonate');
                } else {
                    $location.path('/service-request-list');
                }
            },

            isImpersonationMode: isImpersonationMode,
            isUserImpersonated: isUserImpersonated,

            removeImpersonationContext: function(){
                $log.debug("impersonationService: Removing impersonation context from local storage")
                localStorageService.remove(storageKeys.impersonatedKey);
                localStorageService.remove(storageKeys.loginTypeKey);
            },

            removeLoginType: function () {
                $log.debug("impersonationService: Removing login type key from local storage")
                localStorageService.get(storageKeys.loginTypeKey);
            },

            allowedImpersonation: function(){
                return isImpersonationMode && authenticationService.isAdmin();
            },

            setStoreUsers: function(usersList){
                sessionStorage.setItem(loggedInStoreUsersKey, JSON.stringify(usersList));
            },

            getStoreUsers : function(){
                return JSON.parse(sessionStorage.getItem(loggedInStoreUsersKey));
            },

            removeStoreUsers:function(){
                sessionStorage.removeItem(loggedInStoreUsersKey);
            },

            impersonationHomeURI: $window.location.protocol + "//" + $window.location.host + "/gf-servicemanager-tablet/impersonate.jsp",

            ssoLogoutURI: configuration.authority + "logout"
        }
    }]);